export function validatePass(rule, value, callback) {
  if (value.length == 0) callback();

  let matches = 0;

  if (value.match(/[a-z]/g)) {
    matches = matches + 1;
  }

  if (value.match(/[A-Z]/g)) {
    matches = matches + 1;
  }

  if (value.match(/[0-9]/g)) {
    matches = matches + 1;
  }

  if (value.match(/[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g)) {
    matches = matches + 1;
  }

  if (matches < 2) {
    callback(
      new Error(
        "Needs at least three out of four off: lowercase letter, capital letter, number, special character"
      )
    );
  }

  if (value.length < 12) {
    callback(new Error("Password needs at least 12 letters"));
  }

  callback();
}
